// Mock data for ByteBios website

export const services = [
  {
    id: 1,
    icon: 'Globe',
    title: 'Custom Web Applications',
    description: 'Scalable, secure web apps built with modern frameworks like React, Angular, and Vue.js.'
  },
  {
    id: 2,
    icon: 'Smartphone',
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile applications for iOS and Android.'
  },
  {
    id: 3,
    icon: 'Plug',
    title: 'API Development & Integration',
    description: 'Connect your systems with robust API solutions.'
  },
  {
    id: 4,
    icon: 'Cloud',
    title: 'Cloud Solutions & DevOps',
    description: 'Migrate to the cloud or optimize your existing infrastructure.'
  },
  {
    id: 5,
    icon: 'Building2',
    title: 'Enterprise Software Solutions',
    description: 'Complex business applications designed for large organizations.'
  },
  {
    id: 6,
    icon: 'Palette',
    title: 'UI/UX Design',
    description: 'User-centered design that looks stunning and converts.'
  },
  {
    id: 7,
    icon: 'Database',
    title: 'Data Cleaning and Shaping',
    description: 'Transform raw data into actionable insights with our data processing expertise.'
  },
  {
    id: 8,
    icon: 'Zap',
    title: 'AI & Automation',
    description: 'Workflow automation and intelligent process optimization using N8N, Zapier, and custom solutions.'
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: 'Enterprise Resource Planning',
    category: 'Enterprise Software',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c',
    description: 'Custom ERP solution for manufacturing company'
  },
  {
    id: 2,
    title: 'Mobile Banking App',
    category: 'Mobile Development',
    image: 'https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6',
    description: 'Secure banking application for iOS and Android'
  },
  {
    id: 3,
    title: 'Cloud Migration',
    category: 'Cloud Solutions',
    image: 'https://images.unsplash.com/photo-1683813479742-4730f91fa3ec',
    description: 'Successfully migrated legacy system to AWS cloud'
  },
  {
    id: 4,
    title: 'E-Commerce Platform',
    category: 'Web Development',
    image: 'https://images.unsplash.com/photo-1604781109199-ced99b89b0f6',
    description: 'Scalable online marketplace with advanced features'
  },
  {
    id: 5,
    title: 'Healthcare Management System',
    category: 'Enterprise Software',
    image: 'https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg',
    description: 'Comprehensive patient management solution'
  },
  {
    id: 6,
    title: 'Analytics Dashboard',
    category: 'Data Solutions',
    image: 'https://images.pexels.com/photos/3861958/pexels-photo-3861958.jpeg',
    description: 'Real-time data visualization and reporting platform'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    role: 'CTO, HDFC Bank',
    content: 'ByteBios delivered an exceptional digital banking platform that transformed our customer experience. Their expertise in secure, scalable solutions is outstanding.',
    avatar: 'RK'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    role: 'VP Technology, Axis Bank',
    content: 'The payment gateway integration and API solutions they built have streamlined our operations significantly. Truly professional team with deep technical expertise in fintech.',
    avatar: 'PS'
  },
  {
    id: 3,
    name: 'Amit Patel',
    role: 'Director of IT, LIC',
    content: 'Their enterprise insurance management system transformed our operations completely. The team understood our complex regulatory requirements and delivered a robust, compliant solution.',
    avatar: 'AP'
  },
  {
    id: 4,
    name: 'Sneha Gupta',
    role: 'Head of Digital, WWCRM',
    content: 'Working with ByteBios on our CRM automation project was exceptional. They delivered innovative solutions that increased our operational efficiency by 40%.',
    avatar: 'SG'
  },
  {
    id: 5,
    name: 'Vikram Singh',
    role: 'VP Engineering, TechIndia',
    content: 'The cloud migration and DevOps infrastructure they implemented has been game-changing. Their team proactively addressed all our requirements with exceptional attention to detail.',
    avatar: 'VS'
  },
  {
    id: 6,
    name: 'Anjali Desai',
    role: 'COO, InnovateBiz',
    content: 'ByteBios\'s data processing and analytics platform gave us actionable insights we never had before. Their solution integrates seamlessly with our existing systems.',
    avatar: 'AD'
  }
];

export const clients = [
  { 
    id: 1, 
    name: 'HDFC Bank', 
    logo: `${process.env.PUBLIC_URL}/logos/hdfc.png`
  },
  { 
    id: 2, 
    name: 'Axis Bank', 
    logo: `${process.env.PUBLIC_URL}/logos/axis bank.jpg`
  },
  { 
    id: 3, 
    name: 'LIC', 
    logo: `${process.env.PUBLIC_URL}/logos/lic.png`
  },
  { 
    id: 4, 
    name: 'WWCRM', 
    logo: `${process.env.PUBLIC_URL}/logos/wwcrm.jpg`
  },
  { 
    id: 5, 
    name: 'TechIndia', 
    logo: `${process.env.PUBLIC_URL}/logos/techindia.jpg`
  },
  { 
    id: 6, 
    name: 'InnovateBiz', 
    logo: `${process.env.PUBLIC_URL}/logos/innovatebiz.png`
  },
  { 
    id: 7, 
    name: 'Globus Reach', 
    logo: `${process.env.PUBLIC_URL}/logos/globus reach.png`
  },
  { 
    id: 8, 
    name: 'Rawmatnfab', 
    logo: `${process.env.PUBLIC_URL}/logos/rawmatnfab.png`
  }
];

export const stats = [
  { id: 1, value: '150+', label: 'Projects Completed' },
  { id: 2, value: '50+', label: 'Happy Clients' },
  { id: 3, value: '8+', label: 'Years Experience' },
  { id: 4, value: '25+', label: 'Team Members' }
];